
import { dialogKey, DialogMessage, DialogType } from '@/models/symbols/Dialog';
import { useEventBus } from '@vueuse/core';
import { computed, defineComponent, ref } from 'vue';
import BaseSvg from './BaseSvg.vue';
import BaseButton from './BaseButton.vue';
import BaseCheckbox from './BaseCheckbox.vue';

export default defineComponent({
	components: {
		BaseSvg,
		BaseButton,
		BaseCheckbox
	},
	setup() {
		const bus = useEventBus(dialogKey);
		const show = ref(false);
		const data = ref<DialogMessage>();
		const hasConfirmation = ref(false);

		bus.on((e) => {
			show.value = true;
			data.value = e;
			hasConfirmation.value = !data.value.confirmation;
		});

		const overlayClicked = () => {
			if (data.value?.callback && data.value?.type === DialogType.Redirect) {
				data.value.callback();
			} else if (!data.value?.disableOverlayClick) {
				show.value = !show.value;
			}
		};

		const callBack = () => {
			if (data.value?.callback) {
				data.value.callback();
			}
			show.value = false;
		};

		const className = computed(() => {
			switch (data.value?.type) {
				case DialogType.Warning:
					return 'warning';
				case DialogType.Danger:
					return 'danger';
				case DialogType.Redirect:
				case DialogType.Info:
					return 'info';
				default:
					return 'info';
			}
		});

		return { show, data, callBack, overlayClicked, className, hasConfirmation };
	}
});
